
import { mapActions, mapState } from 'vuex'
import FilterExpansionPanels from '@/components/catalog/FilterExpansionPanels'
import RemoveFilter from '@/components/catalog/RemoveFilter'
import ProductListing from '@/components/catalog/ProductListing'
import LoadingContainer from '@/components/ui/LoadingContainer'
import FilterFlyout from '@/components/catalog/FilterFlyout'

export default {
  name: 'Catalog',
  components: {
    FilterFlyout,
    LoadingContainer,
    FilterExpansionPanels,
    RemoveFilter,
    ProductListing
  },
  timeout: null,
  nuxtI18n: {
    paths: {
      de: '/wohnmobil-kaufen',
      en: '/buy-a-motorhome',
      nl: '/koop-een-camper',
      da: '/kob-en-autocamper',
      es: '/comprar-una-autocaravana',
      cs: '/koupit-automobil',
      pl: '/kup-kamper',
      se: '/koep-en-husbil'
    }
  },
  async fetch () {
    await this.getProducts()
  },

  head () {
    return {
      title: this.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('catalog.description')
        }
      ]
    }
  },

  computed: {
    ...mapState('catalog', ['total', 'products']),
    title () {
      return this.$t('catalog.title', [this.total])
    },
    hasBiddingContextOnRunningProduct () {
      const found = this.products.find((product) => {
        return product?.context?.holdingHighestBid !== undefined && product?.context?.holdingHighestBid !== null &&
          product?.auction?.status === 'running'
      })
      if (found) {
        return true
      }
      return false
    }
  },
  watch: {
    '$route.query': 'getProducts'
  },
  beforeDestroy () {
    this.clearTimeoutIfExist()
  },
  mounted () {
    this.$nextTick(() => {
      this.collect({
        action: 'view'
      })
    })

    this.longPollGetProductsIfHasBiddingContext()
  },

  methods: {
    ...mapActions('useractionlog', ['collect']),

    async getProducts () {
      await this.$store.dispatch('catalog/getProducts', this.$route.query)
    },
    longPollGetProductsIfHasBiddingContext () {
      try {
        this.clearTimeoutIfExist()
        this.$options.timeout = setTimeout(async () => {
          try {
            if (this.hasBiddingContextOnRunningProduct) {
              await this.getProducts()
            }
            // console.log('polling...')
            // console.log('polling done')
          } catch (e) {
            console.error(e)
          } finally {
            this.longPollGetProductsIfHasBiddingContext()
          }
        }, 10000)
      } catch (e) {
        console.error(e)
      }
    },
    clearTimeoutIfExist () {
      try {
        if (this.$options.timeout) {
          // console.log('clearing timeout')
          clearTimeout(this.$options.timeout)
        }
      } catch (e) {
        console.error(e)
      }
    }
  }
}
